/**
 * Inline / panel entity reference chip.
 */

import { crmNavigation } from '../../../services/crm-navigation.js';
import { t } from '../../../i18n.js';

/**
 * @param {Object} reference
 * @param {'inline'|'panel'} [variant]
 * @param {string} [displayLabel]
 * @returns {HTMLElement}
 */
export function createEntityChip(reference, variant = 'inline', displayLabel) {
  const { entityType, entityId, label, canView } = reference;
  const text = displayLabel ?? label;

  const chip = document.createElement('span');
  chip.className = `ai-entity-chip ai-entity-chip--${variant}`;

  if (entityType === 'invalid' || entityId === null) {
    chip.classList.add('ai-entity-chip--invalid');
    chip.textContent = text;
    chip.title = t('ai_no_access');
    return chip;
  }

  if (!crmNavigation.isNavigableEntityType(entityType)) {
    const plain = document.createElement('span');
    plain.textContent = text;
    return plain;
  }

  if (canView === false) {
    chip.classList.add('ai-entity-chip--no-view');
    chip.textContent = text;
    chip.title = t('ai_no_access');
    return chip;
  }

  if (variant === 'list') {
    const link = document.createElement('a');
    link.href = '#';
    link.className = 'ai-entity-chip ai-entity-chip--list';
    link.textContent = text;
    link.addEventListener('click', (e) => {
      e.preventDefault();
      crmNavigation.openEntity(entityType, entityId);
    });
    return link;
  }

  const link = document.createElement('a');
  link.href = '#';
  link.className = `ai-entity-chip ai-entity-chip--${variant}`;
  link.textContent = text;
  link.addEventListener('click', (e) => {
    e.preventDefault();
    crmNavigation.openEntity(entityType, entityId);
  });

  return link;
}
